import { useEffect, useState } from "react"
import Form from "../courseGenerator/form"
import FormLayout from "../courseGenerator/formLayout"
import Privacy from "../courseGenerator/privacy"
import InputField from "../fields/inputField"
import SelectField from "../fields/selectField"
import TextAreaField from "../fields/textAreaField"
import ModelButton from "../modelBtn/modelButton"
import axios from "axios"
import { retrunAssets } from "../../utils/getAssets"
import { DecodeHtml } from "../../utils/decodeHtml"
import { fetchContactUsPrivacyData } from "../../redux/slice/contactUsPrivacyPage"
import { useDispatch, useSelector } from "react-redux"
import emailjs from '@emailjs/browser'

const FeedbackForm = () => {
    const [modalOpen, setModalOpen] = useState(false)

  const closed = () => setModalOpen(false)
  const open = () => setModalOpen(true)
  const state = useSelector(state => state.contactUsPrivacy)
  const dispatch = useDispatch()

  useEffect(() => {
    if (state?.data === null) {
      dispatch(fetchContactUsPrivacyData('personal-data-protection-policy'))
    }
  }, [state, dispatch])

  const contactUs = state?.data?.properties
  const title = contactUs?.title
  const content = DecodeHtml({ html: contactUs?.content?.markup })
  const personalDataAccessForm =
    contactUs?.personalDataAccessForm != null
      ? retrunAssets(contactUs?.personalDataAccessForm[0]?.url)
      : ''
  const personalDataCorrectionForm =
    contactUs?.personalDataCorrectionForm != null
      ? retrunAssets(contactUs?.personalDataCorrectionForm[0]?.url)
      : ''

  const [data, setData] = useState([
    {
      label: 'First Name',
      type: 'text',
      placeholder: 'Please enter your name *',
      name: 'f_name',
      required: true,
      value: ''
    },
    {
      label: 'Email Address',
      type: 'email',
      name: 'email',
      placeholder: 'Please enter your email *',
      required: true,
      value: ''
    },
    {
      label: 'Phone Number',
      type: 'tel',
      placeholder: 'Please enter your phone no *',
      name: 'phone',
      required: true,
      value: ''
    },
    {
      label: 'Address',
      type: 'textarea',
      placeholder: 'Please enter your address *',
      name: 'address',
      required: true,
      value: ''
    },
    {
      label: 'Type',
      type: 'select',
      name: 'student_type',
      required: true,
      options: [
        { value: '1.Suggestion', label: '1.Suggestion' },
        { value: '2 Request', label: '2 Request' },
        { value: '3. Inquiry', label: '3. Inquiry' },
        { value: '4. Compliment', label: '4. Compliment' },
        { value: '5. Complaint', label: '5. Complaint' }
      ],
      value: ''
    },
    {
      label: 'Related Location',
      type: 'select',
      name: 'location',
      required: true,
      options: [
        { value: 'Putrajaya Campus', label: 'Putrajaya Campus' },
        {
          value: 'Sultan Haji Ahmad Shah Campus',
          label: 'Sultan Haji Ahmad Shah Campus'
        }
      ],
      value: ''
    },
    // {
    //   label: 'Program Preference',
    //   type: 'text',
    //   name: 'program',
    //   placeholder: 'Please enter program *',
    //   required: true,
    //   value: ''
    // },
    // {
    //   label: 'Level of Study',
    //   type: 'select',
    //   name: 'level',
    //   required: true,
    //   isEditable: true,
    //   options: [
    //     { value: 'SPM', label: 'SPM' },
    //     { value: 'STPM', label: 'STPM' },
    //     { value: 'IGCSE', label: 'IGCSE' },
    //     { value: 'A-Levels', label: 'Local Student' },
    //     { value: 'Foundation', label: 'Foundation' },
    //     { value: 'Diploma', label: 'Diploma' },
    //     { value: 'Bachelor Degree', label: 'Bachelor Degree' },
    //     { value: 'Masters', label: 'Masters' },
    //     { value: 'PhD', label: 'PhD' }
    //   ],
    //   value: ''
    // },
    // {
    //   label: 'Type of Request Title ( Optional )',
    //   type: 'text',
    //   name: 'title',
    //   placeholder: 'Please enter title *',
    //   required: false,
    //   value: '',
    //   css: 'md:col-span-2'
    // },
    {
      label: 'Subject Description',
      type: 'textarea',
      name: 'description',
      placeholder: 'Please enter subject *',
      required: true,
      value: '',
      css: 'md:col-span-2'
    },
    {
      label: 'Message',
      type: 'textarea',
      placeholder: 'Message for me *',
      name: 'message',
      required: true,
      value: '',
      css: 'md:col-span-2'
    }
  ])

  const [loading, setLoading] = useState(false)
  const updateValue = (name, value) => {
    const newData = [...data]
    const index = newData.findIndex(item => item.name === name)
    newData[index].value = value
    setData(newData)
  }

  const handleSubmit = e => {
    e.preventDefault()

    var templateParams = {
      from_name: data[0].value,
      from_email: data[1].value,
      from_contact: data[2].value,
      studentType: data[4].value,
      // preferrence: data[6].value,
      // levelOfStudy: data[7].value,
      // title: data[8].value,
      message: data[7].value
    }
  
    setLoading(true)
    Promise.all([
      sendApi(),
      emailjs
        .send(
          'service_ixno4sg',
          'template_nmyppnc',
          templateParams,
          'K5NNoBOIPM5UpXPbt'
        )
        .then(
          function (response) {
            console.log('SUCCESS!', response.status, response.text)
            alert('SUCCESS!', response.status, response.text)

            setLoading(false)
            const url = `https://api.whatsapp.com/send?phone=+60133880509&text=%2A%2AYou%20have%20an%20enquiry%20from%20Contact%20Us%2A%2A%0A%0A%2A%2A${data[7].value}%20%2A%2A%0A%2A%2A${data[6].value}%20%2A%2A%0A%0AFull%20Name%20%3A%20${data[0].value}%20%0AEmail%20Address%20%3A%20${data[1].value}%20%0APhone%20Number%20%3A%20${data[2].value}%20%0AStudent%20Type%20%3A%20${data[3].value}%20%0ALevel%20of%20Study%20%3A%20${data[5].value}%20%0AProgram%20Preference%20%3A%20${data[4].value}`
            window.open(url)
          },
          function (error) {
            console.log('FAILED...', error)
            alert('FAILED...', error.text)
            setLoading(false)
          }
        )
    ])
      .then(() => console.log('done'))
      .catch(error => {
        console.error('Error:', error)
      })
  }

  const sendApi = () => {
    const url =
      'http://irecommend.uniten.edu.my/helpdesk/Helpdesk.asp?WCI=Web&WCE=Processing'
    const d = {
      NAME: data[0].value,
      EMAIL: data[1].value,
      PHONE: data[2].value,
      ADDRESS: data[3].value,
      TYPE: data[4].value,
      BUILDINGLEVELID: data[5].value,
      SUBJECT: data[6].value,
      DESCRIPTION: data[7].value,
      SOURCE: 3,
      PRIORITY: 3,
      STAFFID: 1792
    }
    axios
      .post(url, d)
      .then(response => response.json())
      .then(data => {
        console.log('Success:', data)
      })
      .catch(error => {
        console.error('Error:', error)
      })
  }

  return (
    
    <>
     <FormLayout>
          <div className='flex flex-col gap-3 mb-8'>
            <h2 className='text-xl font-bold'>
              FOR ENQUIRIES, SUGGESTIONS, OR COMMENTS PLEASE FILL IN THIS FORM.
            </h2>
            <p className='text-lg text-light'>* These fields are required.</p>
          </div>
          <Form
            key={1}
            handleSubmit={handleSubmit}
            open={open}
            closed={closed}
            modalOpen={modalOpen}
            onLoading={loading}
          >
            {data.map(item => {
              return item.type === 'select' ? (
                <SelectField {...item} updateValue={updateValue} />
              ) : item.type === 'textarea' ? (
                <TextAreaField {...item} updateValue={updateValue} />
              ) : (
                <InputField {...item} updateValue={updateValue} />
              )
            })}
          </Form>
        </FormLayout>
        <ModelButton modalOpen={modalOpen} close={closed}>
          <Privacy
            title={title}
            content={content}
            personalDataAccessForm={personalDataAccessForm}
            personalDataCorrectionForm={personalDataCorrectionForm}
          />
        </ModelButton>
    </>
  )
}

export default FeedbackForm